import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';
import { getRouteByActivityType } from 'src/app/board/activity/activity-shared/activity-shared-routes';
import { RouteActivityType } from 'src/app/board/activity/activity.constants';

export const activitySavingsRoutes: MenuInterface[] = [
    {
        code: 'SavingsNewSaving',
        route: [
            {
                content: 'activity/savings/record/create',
                focus: 'empty'
            }, 'content'
        ]
    },
    {
        code: 'SavingsRecordsList',
        route: [
            {
                content: 'activity/savings/record/list',
                focus: 'empty'
            }, 'content'
        ]
    },
    {
        code: 'SavingsParameters',
        route: [
            {
                content: 'activity/savings/settings/models/list',
                focus: 'empty'
            }, {
                primaryRoute: 'content',
                queryParams: {closeButton: 1}
            }
        ]
    },
    {
        code: 'GestionParamImpressionMasseVUP_ViewModel',
        route: getRouteByActivityType('PrintSalesBalance', RouteActivityType.Savings)
    },
    {
        code: 'SavingsConfigStatusManagement',
        route: getRouteByActivityType('StatusParameters', RouteActivityType.Savings)
    },
];
